import settings from './settings.js'
import routes from './routes.js'

const $inject = ['$provide', '$stateProvider', '$urlRouterProvider', '$ionicConfigProvider', '$sceDelegateProvider', '$compileProvider', 'toastrConfig', 'IdleProvider']

function config(provide, stateProvider, urlRouterProvider, ionicConfigProvider, sceDelegateProvider, compileProvider, toastrConfig, IdleProvider) {
    const customExceptionHandler = function(delegate, injector) {
        let lastLogAppExceptionMoment = moment(),
            errorCounter = 0,
            requiredDiffSeconds = 0;

        const handleCustomException = (exception, cause) => {
            return new Promise((resolve, reject) => {
                if (!settings.logAppExceptionsToServer || !moment.isMoment(lastLogAppExceptionMoment) || moment().diff(lastLogAppExceptionMoment, 'seconds') < requiredDiffSeconds)
                    return resolve(null);

                switch (errorCounter++) {
                    case 5:
                        requiredDiffSeconds = 20;
                        break;
                    case 15:
                        requiredDiffSeconds = 60;
                        break;
                    case 30:
                        requiredDiffSeconds = 120;
                        break;
                    case 50:
                        requiredDiffSeconds = 300;
                        break;
                    case 75:
                        requiredDiffSeconds = 600;
                        break;
                    case 100:
                        requiredDiffSeconds = 1800;
                        break;                  
                }

                const http = injector.get("$http");

                if (!http)
                    return resolve(null);

                lastLogAppExceptionMoment = moment();

                http({
                    method: 'POST',
                    url: settings.baseUrl + '?controller=ajax&logappexception=1' + '&appauth=' + settings.appAuthSecret,
                    data: {
                        app_id: settings.appId,
                        appversion: settings.appVersion,
                        device: window.device,
                        message: exception.message,
                        stack: exception.stack,
                        cause: cause ? cause : null
                    }
                }).then((response) => resolve(true)).catch((error) => resolve(false));
            });
        };

        return function (exception, cause) {
            handleCustomException(exception, cause);
            delegate(exception, cause);
        }
    };

    //Try to capture exceptions and send them to server.
    provide.decorator("$exceptionHandler", ['$delegate', '$injector', customExceptionHandler]);

	const states = Object.assign(routes, settings.states)

    Object.keys(states).forEach(name => {
        stateProvider.state(name, states[name]);
    });

    //This is where we go at startup
    urlRouterProvider.otherwise(settings.stateOtherwise);

    const escape = (s) => String(s).replace(/[\\^$*+?.()|[\]{}]/g, '\\$&');

    sceDelegateProvider.resourceUrlWhitelist(['self', new RegExp('^(http[s]?):\/\/(w{3}.)?youtube\.com\/.+$')]);
    sceDelegateProvider.resourceUrlWhitelist(['self', new RegExp(escape(settings.baseUrl), 'g')]);

    //iOS seems to need this to show images.
    compileProvider.imgSrcSanitizationWhitelist(/^\s*(https?|ftp|file|blob|ionic):|data:image\//);

    ionicConfigProvider.tabs.position('bottom');
    ionicConfigProvider.navBar.alignTitle('center');

    //Try to change back button text from localStorage langCode
    let langCode = localStorage.getItem('wiseLang-' + settings.appId);

    if (typeof langCode === 'string') {
        console.log("config langCode was '" + langCode + "'");

        if (langCode.toLowerCase() === 'fi-fi')
            langCode = 'fi-FI';

        if (langCode.toLowerCase() === 'sv-se')
            langCode = 'sv-SE';

        if (langCode.toLowerCase() === 'en-gb')
            langCode = 'en-GB';

        if (langCode.toLowerCase() === 'de-de')
            langCode = 'de-DE';    
    }

	//If no language code set in localStorage, use finnish by default
    if (!langCode)
        langCode = 'en-GB';

    _setLanguage(langCode);
    
    ionicConfigProvider.backButton.text(_locale('back').ucfirst());  

    angular.extend(toastrConfig, {
        autoDismiss: false,
        containerId: 'toast-container',
        maxOpened: 0,
        newestOnTop: true,
        positionClass: 'toast-top-full-width',
        preventDuplicates: false,
        preventOpenDuplicates: false,
        target: 'body'     
    });

	//Init jumppakalenteri idles settings. Used by Jumppakalenteri to autologout user.
    IdleProvider.idle(settings.idle.warning); //How long until timeout warning is given
    IdleProvider.timeout(settings.idle.timeout); //After that, how long until timeout
}

config.$inject = $inject

export default config